import { render, staticRenderFns } from "./FTPConfigurationDetails.vue?vue&type=template&id=e0775b38&"
import script from "./FTPConfigurationDetails.vue?vue&type=script&lang=js&"
export * from "./FTPConfigurationDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e0775b38')) {
      api.createRecord('e0775b38', component.options)
    } else {
      api.reload('e0775b38', component.options)
    }
    module.hot.accept("./FTPConfigurationDetails.vue?vue&type=template&id=e0775b38&", function () {
      api.rerender('e0775b38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/routing/FTP/FTPConfigurationDetails.vue"
export default component.exports